import { makeStyles } from "@mui/styles";

const footerStyle = makeStyles((theme) => ({
  footerContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem 2rem",
    backgroundColor: theme.palette.background.gray,
    borderTop: "1px solid #ddd",
    paddingBottom: '3rem',
  },
  linksContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "3rem",
    marginBottom: "0.5rem",
    [theme.breakpoints.down('sm')]: {
      gap: "1.33rem",
    },
  },
  link: {
    color: theme.palette.text.third + '!important',
    textDecoration: "none",
    fontSize: "1rem",
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
  iconsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "1.2rem",
    marginTop: "1rem",
  },
  icon: {
    marginBottom: '2rem',
    "&:hover": {
        color: theme.palette.secondary.main,
    },
  },
  copyright: {
    marginTop: '2rem !important',
    fontSize: "1rem",
    textAlign: "center",
    color: theme.palette.text.third,
  },
}));

export default footerStyle;